import React from 'react';
import { Building2, Globe, Hash } from "lucide-react";
import { UpdateHotelRequest } from '@repo/types';
import { SectionCard, DetailItem } from './HotelCommon';

interface BasicInfoSectionProps {
    editForm: Partial<UpdateHotelRequest>;
    isEditMode: boolean;
    setEditForm: (form: Partial<UpdateHotelRequest>) => void;
    salesmanCode: string;
}

export const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
    editForm,
    isEditMode,
    setEditForm,
    salesmanCode
}) => {
    return (
        <SectionCard title="Basic Information" icon={Building2}>
            <DetailItem
                label="Salesman Code"
                value={salesmanCode || "N/A"}
                icon={Globe}
            />
            <DetailItem
                label="Hotel Name"
                value={editForm.HotelName || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, HotelName: val })}
                icon={Building2}
            />
            <DetailItem
                label="Website"
                value={editForm.Website || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, Website: val })}
                icon={Globe}
            />
            <DetailItem
                label="Tax Number"
                value={editForm.TaxNumber || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, TaxNumber: val })}
                icon={Hash}
            />
        </SectionCard>
    );
};
